import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userWrapper: {
    display: 'flex',
    height: 'auto',
    width: '100%',
    gap: theme.spacing(1),
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    borderRadius: '4px',
    color: 'unset',
    backgroundColor: 'transparent',
    border: `1px solid transparent`,
    transition: 'border 0.3s ease',
    boxSizing: 'border-box',
  },

  userWrapperHover: {
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: 'pointer',
    },
  },

  avatarWrapper: {
    minWidth: '100px',
  },

  userDetails: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  },
  infoWrapper: {
    display: 'flex',

    alignItems: 'center',
    flex: 1,
  },

  infoName: {
    fontWeight: '600',
  },

  controlWrapper: {
    display: 'flex',
    gap: '8px',
    //justifyContent: 'flex-end',
  },

  userWrapperAdjacent: {
    marginTop: '8px',
  },
}));
